// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (c) 2021 SAP SE or an SAP affiliate company and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-bulk-edit-container {
  font-size: var(--theia-ui-font-size1);
}

.theia-bulk-edit-container .bulkEditNode,
.theia-bulk-edit-container .bulkEditInfoNode {
  display: flex;
  align-items: center;
}

.theia-bulk-edit-container .bulkEditNode,
.theia-bulk-edit-container .bulkEditInfoNode {
  width: calc(100% - 32px);
}

.theia-bulk-edit-container .bulkEditNode div,
.theia-bulk-edit-container .bulkEditInfoNode div {
  margin-right: 5px;
}

.theia-bulk-edit-container .bulkEditInfoNode .name,
.theia-bulk-edit-container .bulkEditInfoNode .path {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-bulk-edit-container .bulkEditInfoNode .path {
  font-size: var(--theia-ui-font-size0);
  color: var(--theia-descriptionForeground);
  align-self: flex-end;
  white-space: nowrap;
}

.theia-bulk-edit-container .bulkEditNode .message {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theia-bulk-edit-container .bulkEditNode .message .replaced-text {
  text-decoration: line-through;
  background: var(--theia-diffEditor-removedTextBackground);
  border-color: var(--theia-diffEditor-removedTextBorder);
}

.theia-bulk-edit-container .bulkEditNode .message .inserted-text {
  background: var(--theia-diffEditor-insertedTextBackground);
  border: 1px solid var(--theia-diffEditor-insertedTextBorder);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/bulk-edit/src/browser/style/bulk-edit.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,yDAAyD;EACzD,uDAAuD;AACzD;;AAEA;EACE,0DAA0D;EAC1D,4DAA4D;AAC9D","sourcesContent":["/********************************************************************************\n * Copyright (c) 2021 SAP SE or an SAP affiliate company and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-bulk-edit-container {\n  font-size: var(--theia-ui-font-size1);\n}\n\n.theia-bulk-edit-container .bulkEditNode,\n.theia-bulk-edit-container .bulkEditInfoNode {\n  display: flex;\n  align-items: center;\n}\n\n.theia-bulk-edit-container .bulkEditNode,\n.theia-bulk-edit-container .bulkEditInfoNode {\n  width: calc(100% - 32px);\n}\n\n.theia-bulk-edit-container .bulkEditNode div,\n.theia-bulk-edit-container .bulkEditInfoNode div {\n  margin-right: 5px;\n}\n\n.theia-bulk-edit-container .bulkEditInfoNode .name,\n.theia-bulk-edit-container .bulkEditInfoNode .path {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-bulk-edit-container .bulkEditInfoNode .path {\n  font-size: var(--theia-ui-font-size0);\n  color: var(--theia-descriptionForeground);\n  align-self: flex-end;\n  white-space: nowrap;\n}\n\n.theia-bulk-edit-container .bulkEditNode .message {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.theia-bulk-edit-container .bulkEditNode .message .replaced-text {\n  text-decoration: line-through;\n  background: var(--theia-diffEditor-removedTextBackground);\n  border-color: var(--theia-diffEditor-removedTextBorder);\n}\n\n.theia-bulk-edit-container .bulkEditNode .message .inserted-text {\n  background: var(--theia-diffEditor-insertedTextBackground);\n  border: 1px solid var(--theia-diffEditor-insertedTextBorder);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
